<template>
  <el-dialog
    :title="$t('dashboard-bi::board-management::角色选择')"
    :visible.sync="showRole"
    width="690px"
    :destroy-on-close="true"
  >
    <el-transfer
      v-model="distribution"
      filterable
      :filter-placeholder="$t('dashboard-bi::board-management::select-folder-holder')"
      class="boardManage--dialog__transfer"
      :titles="[$t('dashboard-bi::board-management::角色列表'), $t('dashboard-bi::board-management::已选角色')]"
      :data="undistribution"
      :props="{ key: 'roleId', label: 'roleName' }"
    ></el-transfer>
    <div slot="footer">
      <el-button @click="showRole = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit" :loading="saveLoading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRoleList, setRoleAuth } from '@/server/dashboard'
export default {
  data() {
    return {
      showRole: false,
      distribution: [],
      undistribution: [],
      saveLoading: false,
    }
  },
  props: {
    value: {},
    editRow: {
      default: () => {},
    },
  },
  methods: {
    async getList() {
      const { result } = await getRoleList({ boardID: this.editRow.boardID })
      if (result.code === this.$code) {
        this.distribution = result.data.distribution.map(item => item.roleId)
        this.undistribution = [...result.data.distribution, ...result.data.undistribution]
      } else {
        this.$message.error(result.msg)
      }
    },
    async submit() {
      const { result } = await setRoleAuth({
        boardID: this.editRow.boardID,
        groups: this.distribution.map(item => Number(item)),
      })
      if (result.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.showRole = false
      } else {
        this.$message.error(result.msg)
      }
    },
  },
  watch: {
    value(val) {
      this.showRole = val
      if (val) {
        this.getList()
      }
    },
    showRole(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="scss" scoped>
.boardManage--dialog__transfer {
  .el-transfer-panel__filter {
    width: auto;
  }
}
.boardManage--dialog {
  &__transfer {
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/.el-transfer-panel {
      width: 240px;
    }
    /deep/ .el-transfer__button {
      margin: 16px 0;
      display: block;
      background: #0560fd;
      color: #fff;
    }
    /deep/ .is-disabled {
      background: rgba(54, 109, 255, 0.2);
    }
  }
}
</style>
